export const RESET_DATA_REQUEST = 'resetData/RESET_DATA_REQUEST';
export const RESET_DATA_SUCCESS = 'resetData/RESET_DATA_SUCCESS';
export const RESET_DATA_FAILURE = 'resetData/RESET_DATA_FAILURE';

export const RESET_STATUS_REQUEST = 'resetData/RESET_STATUS_REQUEST';
export const RESET_STATUS_SUCCESS = 'resetData/RESET_STATUS_SUCCESS';
export const RESET_STATUS_FAILURE = 'resetData/RESET_STATUS_FAILURE';
